// app/components/ModalController.tsx
'use client'

import { usePathname } from 'next/navigation'

import PopupGetBraza from './popup-getbraza'

const ModalController: React.FC = () => {
  const pathname = usePathname()
  const isBrazaPage = pathname.startsWith('/getbraza')

  return isBrazaPage ? <PopupGetBraza /> : null
}

export default ModalController
